/**
 * Directive: treeList
 */
angular.module('acme.common.directive.treeList', [])
.directive('treeList', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/treeList/treeList.tpl.html',
      scope: {
        'items': '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.treeList = "Your spankin new treeList!";

      }]

    };

}]);